<template>
    <div data-component="AmsPriceIndicatorModalInfo" class="text-text">
        <span class="mr-4 font-bold">
            {{ infoData.prefix }}
        </span>
        <span>{{ infoData.text }}</span>
    </div>
</template>

<script lang="ts" setup>
const infoData = {
    prefix: 'Hinweis:',
    text: 'meinestadt.de arbeitet dabei nicht mit Händlern zusammen und führt eine unabhängige, neutrale Bewertung durch. Die Preisbewertungsampel dient hier nur als Orientierung – prüfe alle Inserate auf Herz und Nieren und hole dir eine fachliche Unterstützung hinzu, der du vertraust.',
}
</script>
